import { createContext } from 'react'

const ResponsiveContext = createContext({ isMobile: false })

export default ResponsiveContext
